const componentsComboboxInstallableSoftwareSelectorComboboxEn = {
  clearSelectionAriaLabel: 'Clear selection',
  searchPlaceholder: 'Search installable software...'
};
export default componentsComboboxInstallableSoftwareSelectorComboboxEn;